
  import React from 'react';
  import styled from 'styled-components';
  import { Check } from 'lucide-react';
  
  const StepsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 2rem;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 2px;
      background: #e2e8f0;
      z-index: 0;
    }
  `;
  
const Step = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: ${props => props.active ? '#1e40af' : '#e2e8f0'};
  color: ${props => props.active ? 'white' : '#64748b'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  
  &:hover {
    ${props => props.clickable && `
      background: ${props.active ? '#1d4ed8' : '#cbd5e1'};
      transform: scale(1.05);
    `}
  }
  
  &::after {
    content: '${props => props.label}';
    position: absolute;
    top: 100%;
    font-size: 0.75rem;
    margin-top: 0.5rem;
    white-space: nowrap;
  }
`;
  
export const Steps = ({ currentStep, navigateToStep, canNavigateToStep }) => {
  const steps = [
    { label: 'Location', number: 1 },
    { label: 'Questions', number: 2 },
    { label: 'Destination', number: 3 },
    { label: 'Vehicle', number: 4 },
    { label: 'Summary', number: 5 }
  ];

  const handleStepClick = (stepNumber) => {
    if (canNavigateToStep && canNavigateToStep(stepNumber) && navigateToStep) {
      navigateToStep(stepNumber);
    }
  };

  return (
    <StepsContainer>
      {steps.map(step => {
        const isClickable = canNavigateToStep && canNavigateToStep(step.number);
        return (
          <Step
            key={step.number}
            active={currentStep >= step.number}
            label={step.label}
            clickable={isClickable}
            onClick={() => handleStepClick(step.number)}
          >
            {currentStep > step.number ? (
              <Check size={16} />
            ) : (
              step.number
            )}
          </Step>
        );
      })}
    </StepsContainer>
  );
};
  